import api, { ApiResponse } from './api';

export interface McpConnection {
  client_id: string;
  client_name: string;
  user_id: string;
  user: string;
  sessions: number;
  first_connected: string;
  last_activity: string;
}

export interface McpRevokeInput {
  client_id: string;
  user_id: string;
}

export const mcpConnectionsService = {
  list: async (): Promise<McpConnection[]> => {
    const response = await api.get<ApiResponse<McpConnection[]>>('/mcp-connections');
    return response.data.data!;
  },

  revoke: async (input: McpRevokeInput): Promise<{ revoked: number }> => {
    const response = await api.post<ApiResponse<{ revoked: number }>>('/mcp-connections/revoke', input);
    return response.data.data!;
  },
};
